<template>
    <div
        class="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center"
        style="
            padding: 1rem 1rem;
            border-bottom: 1px solid #f5f5f5;
            font-size: 0.85rem;
        "
    >
        <div class="d-flex flex-column justify-content-center">
            <el-rate
                v-model="element.content.Level"
                :colors="colors"
                disabled
            ></el-rate>
            <div class="text-justify mt-1">
                <span>Evaluated the usage time of image</span>
                <span class="ml-2">
                    <el-button
                        @click="
                            pushUrl(
                                element.serviceType === 1
                                    ? routeUrl.GPUHUB
                                    : routeUrl.CPUHUB
                            )
                        "
                        type="text"
                        >#{{ element.machineId }}</el-button
                    ></span
                >
                <span class="ml-md-2">from</span>
                <span class="ml-md-2" style="font-style: italic">{{
                    element.startTime | pretyDateUtcToLocal
                }}</span>
                <span class="ml-md-2">to</span>
                <span class="ml-md-2" style="font-style: italic">{{
                    element.endTime | dateFull
                }}</span>
            </div>
            <div
                v-if="element.ratingResponse"
                v-html="element.ratingResponse.replace(/\n/g, '<br>\n')"
                class="text-justify mt-1 mb-3"
                style="
                    color: #1976d2;
                    background-color: #e3f2fd;
                    padding: 1rem;
                    border-radius: 10px;
                "
            ></div>
            <div class="mt-1" style="color: #bdbdbd; font-size: 0.75rem">
                {{ element.createdAt | dateFull }}
            </div>
        </div>
        <div class="d-flex flex-column justify-content-md-center ml-md-10">
            <div> 
                <el-button
                    @click="pushUrl(routeUrl.BILLING_HISTORY)"
                    style="font-size: 0.8rem"
                    type="text"
                    >View details billing</el-button
                >
            </div>
        </div>
    </div>
</template>

<script>
// Extend
import base from "@/scripts/base";

export default {
    extends: base,

    data() {
        return {
            colors: ["red", "#F7BA2A", "#FF9900"],
        };
    },

    props: {
        element: {
            type: Object,
            default: null,
        },
    },

    methods: {},
};
</script>